import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=261f56b0&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=261f56b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f56b0",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/home_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fhome%2FHomePage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports